// Desc: Page to add a new WhatsApp instance
// Update: 17/07/2025

// React Components and DOM Elements
import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";

// Material UI Components
import Box from "@mui/material/Box";

// Components and functions for the project
import { RequestCreate } from "../../api/aws/Request/RequestCreate";
import CardListG from "../../components/CardList/CardListG";
import CardModal from "../../components/CardList/CardModal";
import HeaderPage from "../../components/HeaderPage/HeaderPage";
import Titles from "../../components/Titles/Titles";
import { ChannelAddEmail } from "../../api/aws/Channels/ChannelAddEmail";
import { ChannelAddSMS } from "../../api/aws/Channels/ChannelAddSMS";
import { ChannelAddWppAPI } from "../../api/aws/Channels/ChannelAddWppAPI";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import ThemeColors from "../../components/ThemeColors/ThemeColors";
import ModalR from "../../components/Modals/ModalR";
import CampaignModal from "../../components/Modals/CampaignModal";
import Loading from "../../components/Loading/Loading";
import use123zapStore from "../../context/123zapStore";
import Footer from "../../components/Footer/Footer";

// Render The Page
function ChannelPageAdd() {
  const userInfo = use123zapStore((state) => state.userInfo);
  const planoAtual = use123zapStore((state) => state.planoAtual);
  let Navigate = useNavigate();

  const creatingCampaignWithHelpMode =
    JSON.parse(sessionStorage.getItem("creating_campaign")) || null;
  const [input, setInput] = useState("");
  const [input2, setInput2] = useState("");
  const [input3, setInput3] = useState("");

  const [showModal, setShowModal] = useState(false);
  const [modalType, setModalType] = useState("");
  const [loading, setLoading] = useState(false);

  const [openModalConfirmOK, setOpenModalConfirmOK] = useState(false);
  const [openModalCampaign, setOpenModalCampaign] = useState(false);
  const [openModalConfirmError, setOpenModalConfirmError] = useState(false);

  const [messageError, setMessageError] = useState("");
  const [mensagem, setMensagem] = useState("");

  const mapPlanFunctionsAllowed = {
    FreeZap: [],
    StartZap: ["WhatsApp Web"],
    ProZap: ["WhatsApp Web", "WhatsApp API"],
    UltraZap: ["WhatsApp Web", "WhatsApp API", "SMS", "Email"],
  };

  const openModal = (type) => {
    setModalType(type);
    setShowModal(true);
  };

  const addRequest = async () => {
    let info = {
      title: "Solicitação de Adição de Canal " + modalType,
      description:
        "Solicitação de adição de canal " +
        modalType +
        " para envio de mensagens personalizadas para os clientes.",
      status: "Pendente",
      creationdate: new Date().toISOString(),
      updatedate: new Date().toISOString(),
      requesterid: userInfo["EMAIL"],
      user_client: userInfo["UUID"],
      body: {
        type: modalType,
        data: { input, input2, input3 },
      },
      priority: "A Definir",
      sector: "Avisos",
    };

    const addRequestUser = await RequestCreate(info);
  };

  const HandleAddChannel = async () => {
    setLoading(true);

    if (modalType === "Email") {
      try {
        const addEmail = await ChannelAddEmail({ email: input, name: input2 });
        if (addEmail.message === "success") {
          let mensagem = (
            <span>
              Seu email foi <b style={{ color: "#8033F4" }}>adicionado</b> com
              sucesso!
              <br />
              <br />
              1. Verifique sua caixa de entrada para confirmar o email.
              <br />
              2. Após a confirmação, em até{" "}
              <strong style={{ color: "#000" }}>10 minutos</strong> seu canal de
              email estará disponível para uso.
            </span>
          );

          setMensagem(mensagem);
          setShowModal(false);
          creatingCampaignWithHelpMode
            ? setOpenModalCampaign(true)
            : setOpenModalConfirmOK(true);
          addRequest();
          setInput("");
          setInput2("");
        }
      } catch (error) {
        let mensagem = (
          <span>
            Ocorreu um erro ao adicionar o email.
            <br /> Consulte nosso <b style={{ color: "#8033F4" }}>
              suporte
            </b>{" "}
            para ficar por dentro de todos os detalhes e orientações.
          </span>
        );

        setMessageError(mensagem);
        setShowModal(false);
        setOpenModalConfirmError(true);
        setInput("");
        setInput2("");
      } finally {
        setLoading(false);
      }
    } else if (modalType === "SMS") {
      try {
        const addSMS = await ChannelAddSMS({ confirm: input });

        if (addSMS.message === "success") {
          let mensagem = (
            <span>
              Seu canal de SMS foi{" "}
              <b style={{ color: "#8033F4" }}>adicionado</b> com sucesso!
              <br /> No Brasil, o envio de SMS é feito através de um número
              curto.
            </span>
          );
          setMensagem(mensagem);
          setShowModal(false);
          creatingCampaignWithHelpMode
            ? setOpenModalCampaign(true)
            : setOpenModalConfirmOK(true);
          addRequest();
          setInput("");
          setInput2("");
        }
      } catch (error) {
        let mensagem = null;

        if (
          error &&
          error.message === "Já existe um canal SMS para este cliente"
        ) {
          mensagem = (
            <span>
              Este cliente já possui um canal SMS ativo.
              <br />
              <br />O canal de SMS é um recurso unico por cliente. Consulte
              nosso <b style={{ color: "#8033F4" }}>suporte</b> para ficar por
              dentro de todos os detalhes e orientações.
            </span>
          );
        } else {
          mensagem = (
            <span>
              Ocorreu um erro ao adicionar o canal SMS.
              <br />
              <br /> Caso o erro persista, consulte nosso{" "}
              <b style={{ color: "#8033F4" }}>suporte</b> para ficar por dentro
              de todos os detalhes e orientações.
            </span>
          );
        }

        setMessageError(mensagem);
        setShowModal(false);
        setOpenModalConfirmError(true);
        setInput("");
        setInput2("");
      } finally {
        setLoading(false);
      }
    } else if (modalType === "WhatsApp Business") {
      try {
        const addWppAPI = await ChannelAddWppAPI({
          url: input,
          token: input2,
          name: input3,
        });

        if (addWppAPI.message === "success") {
          let mensagem = (
            <span>
              Seu canal de WhatsApp API foi{" "}
              <b style={{ color: "#8033F4" }}>adicionado</b> com sucesso!
              <br />
            </span>
          );

          setMensagem(mensagem);
          setShowModal(false);
          creatingCampaignWithHelpMode
            ? setOpenModalCampaign(true)
            : setOpenModalConfirmOK(true);
          addRequest();
          setInput("");
          setInput2("");
          setInput3("");
        }
      } catch (error) {
        let mensagem = null;

        if (
          error &&
          error.message === "Já existe um canal WhatsApp API para este cliente"
        ) {
          mensagem = (
            <span>
              Este cliente já possui um canal WhatsApp API ativo.
              <br /> Consulte nosso <b style={{ color: "#8033F4" }}>
                suporte
              </b>{" "}
              para ficar por dentro de todos os detalhes e orientações.
            </span>
          );
        } else {
          mensagem = (
            <span>
              Ocorreu um erro ao adicionar o canal WhatsApp API.
              <br /> Consulte nosso <b style={{ color: "#8033F4" }}>
                suporte
              </b>{" "}
              para ficar por dentro de todos os detalhes e orientações.
            </span>
          );
        }

        setMessageError(mensagem);
        setShowModal(false);
        setOpenModalConfirmError(true);
        setInput("");
        setInput2("");
        setInput3("");
      } finally {
        setLoading(false);
      }
    }
  };

  const HandleRedirectAdd = () => {
    Navigate("/canais/adicionar/whatsapp");
  };

  const HandleRedirectAddSMS = () => {
    Navigate("/canais/adicionar/sms");
  };

  const HandleChannels = () => {
    creatingCampaignWithHelpMode === true
      ? Navigate("/campanhas/adicionar")
      : Navigate("/canais");
  };

  const canAddChannel = (channel) => {
    if (!mapPlanFunctionsAllowed[planoAtual]) {
      return false;
    }
    return mapPlanFunctionsAllowed[planoAtual].includes(channel);
  };

  const channelData = [
    {
      title: "WhatsApp Web",
      subtitle: "Envie mensagens rapidamente", // frase curta e direta
      text: "Ideal para envios simples e de baixo volume, como notificações e pequenos atendimentos.",
      icon: "WhatsApp",
      corFundo: "#DDD4FF",
      titleColor: "#8033F4",
      onClick: HandleRedirectAdd,
      pago: canAddChannel("WhatsApp Web"),
    },
    {
      title: "WhatsApp API",
      subtitle: "Automatize envios de alto volume", // frase curta
      text: "Solução robusta para alto volume, automações e campanhas contínuas.",
      icon: "WhatsApp Business",
      corFundo: "#DDD4FF",
      titleColor: "#8033F4",
      onClick: () => Navigate("/canais/adicionar/whatsapp-business"),
      pago: canAddChannel("WhatsApp API"),
    },
    {
      title: "Email",
      subtitle: "Envie notificações por e-mail", // frase curta
      text: "Envie notificações por e-mail e diversifique seus canais de comunicação.",
      icon: "Email",
      corFundo: "#DDD4FF",
      titleColor: "#8033F4",
      onClick: () => Navigate("/canais/adicionar/email"),
      pago: canAddChannel("Email"),
    },
    {
      title: "SMS",
      subtitle: "Envie mensagens curtas e rápidas", // frase curta
      text: "Perfeito para mensagens curtas como códigos, cobranças ou avisos rápidos.",
      icon: "SMS",
      corFundo: "#DDD4FF",
      titleColor: "#8033F4",
      onClick: HandleRedirectAddSMS,
      pago: canAddChannel("SMS"),
    },
  ];

  const HandleWhatsApp = () => {
    window.open(
      "https://wa.me/553121300297?text=Ol%C3%A1%2C%20estou%20precisando%20de%20suporte!%20",
      "_blank"
    );
  };

  if (planoAtual === null) {
    return <Loading open={true} />;
  }

  return (
    <>
      <HeaderPage title="Add WhatsApp Instance" />
      <Box
        sx={{
          position: "relative",
          width: "100%",
          minHeight: { sm: "calc(100vh - 100px)" },
          paddingBottom: 10,
        }}
      >
        <Box
          sx={{ padding: { xs: "30px 30px 0 30px", sm: "30px 30px 0 30px" } }}
        >
          <Titles
            styles={{ fontSize: { xs: "20px", sm: "24px" } }}
            children={"Qual Canal deseja adicionar?"}
            color={"#848484"}
          />
          <CardListG data={channelData} showText />
          <div style={{ padding: "40px 0 0 0", marginTop: "auto" }}>
            <Footer />
          </div>
        </Box>

        <CardModal
          isOpen={showModal}
          onClose={() => setShowModal(false)}
          type={modalType}
          input={input}
          setInput={setInput}
          onConfirm={HandleAddChannel}
          input2={input2}
          setInput2={setInput2}
          input3={input3}
          setInput3={setInput3}
          loading={loading}
        />
      </Box>
      <ModalR
        cancelText="Fechar"
        color={ThemeColors.purple500}
        confirmText="Verificar meus canais"
        subTitle={mensagem}
        isOpen={openModalConfirmOK}
        onClose={() => setOpenModalConfirmOK(false)}
        onConfirm={HandleChannels}
        title={""}
        emoji="emoji02"
        iconColor={ThemeColors.purple400}
      />

      <CampaignModal
        cancelText="Adicionar mais um canal"
        confirmText="Retornar ao formulário"
        subTitle={
          "Percebemos que você está configurando uma campanha. Gostaria de retornar ao formulário?"
        }
        isOpen={openModalCampaign}
        onClose={() => setOpenModalCampaign(false)}
        onCancel={() => Navigate("/canais/adicionar")}
        onConfirm={() => (
          HandleChannels(), sessionStorage.setItem("ReturToCampaign", true)
        )}
        title={"Canal adicionado com sucesso"}
        iconColor={ThemeColors.purple400}
      />

      <ModalR
        cancelText="Fechar"
        color={ThemeColors.red500}
        confirmText="Chamar Suporte"
        subTitle={messageError}
        isOpen={openModalConfirmError}
        onClose={() => setOpenModalConfirmError(false)}
        onConfirm={HandleWhatsApp}
        title={""}
        emoji="emoji10"
        iconColor={ThemeColors.red400}
        iconButton={<WhatsAppIcon sx={{ color: "white" }} />}
      />
    </>
  );
}

export default ChannelPageAdd;
